import { render, staticRenderFns } from "./planDetail.vue?vue&type=template&id=1b772c8e&scoped=true"
import script from "./planDetail.vue?vue&type=script&lang=js"
export * from "./planDetail.vue?vue&type=script&lang=js"
import style0 from "./planDetail.vue?vue&type=style&index=0&id=1b772c8e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b772c8e",
  null
  
)

export default component.exports